import { useMemo, useState } from "react";
import { useServerSdk } from "../../RootNavigator/services/ServerSdk";
import Spacer from "@hpo/client/utilities/Spacer";

import { useSubmitCallback } from "@hpo/client/utilities/useSubmitCallback";
import FieldsForm from "@hpo/client/utilities/fields/FieldsForm";
import Button from "@hpo/client/components/Button";
import MultiSelectField from "@hpo/client/utilities/fields/MultiSelectField";
import { Tag } from "@hpo/client/models/Tag";

type IndicatorTagsEditorProps = {
  tags: Array<Tag>;
  onDone: (tags: Array<Tag>) => unknown;
};

export default function IndicatorTagsEditor(props: IndicatorTagsEditorProps) {
  const { tags, onDone } = props;
  const server = useServerSdk();
  const allTags = server.suspender.use(server.getTags());

  const [value, setValue] = useState<Array<string>>(tags.map((t) => t.id));

  const selection = useMemo(() => {
    return value
      .map((v) => allTags.find((t) => t.id === v))
      .filter(Boolean) as Array<Tag>;
  }, [value, allTags]);

  const [onSubmit, submission] = useSubmitCallback(async () => {
    await onDone(selection);
  }, [selection, onDone]);

  return (
    <FieldsForm onSubmit={onSubmit}>
      <MultiSelectField
        label="Etiquettes de l'indicateur"
        value={value}
        onChange={setValue}
        options={allTags}
        keyExtractor={(tag) => tag.id}
        renderOption={(tag) => ({ label: tag.label })}
      />
      <Spacer />
      <Button submit label="Valider" loading={submission.running} />
    </FieldsForm>
  );
}
